/**
 * 字符串格式化
 * @param args
 */
function formatString(...args: any[]) {
  //@ts-ignore
  let result: string = this;
  for (const arg of args) {
    result = result.replace("%s", arg);
  }
  return result.replaceAll("%s", "");
}
/**
 * 浮点数运算
 * @param num
 * @param precision
 */
function floatCompute(num: number, precision = 10): number {
  const factor = Math.pow(10, precision);
  //@ts-ignore
  return (Math.round((this as number) * factor) + Math.round(num * factor)) / factor;
}

export const useBasicDataTypeMethods = () => {
  String.prototype._format = formatString;
  Number.prototype._fpo = floatCompute;
};
